import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC2SiKoXDL5a3gNLma2m8TPjOXU1iWpmzA",
  authDomain: "eaziquote-25657.firebaseapp.com",
  projectId: "eaziquote-25657",
  storageBucket: "eaziquote-25657.firebasestorage.app",
  messagingSenderId: "759897513852",
  appId: "1:759897513852:web:e36d2e90224a997b5dcef9",
};

export const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
